export default __webpack_public_path__ + "static/media/TeamsAssets-Light.e8bd73e2.woff2";